import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'

import { StrategyAdminWithState } from './pages/strategies-with-state'

export const StrategyAdmin = () => (
  <LeftSideBar
    leftElement={<Navigation />}
    mainElement={<StrategyAdminWithState />}
    topBarElement={<UserMenuTopBar />}
  />
)
